import { useEffect, useState } from "react";
import { toast } from "sonner";
import { API_ENDPOINTS } from "../utils/urls";
import api from "../utils/api";

interface Props {
  setShowForm: (value: boolean) => void;
}

const AddCategory: React.FC<Props> = ({ setShowForm }) => {
  const [categories, setCategories] = useState([{ name: "" }]);

  useEffect(() => {
    const handleKeyDown = (e: any) => {
      if (e.key === "Escape") setShowForm(false);
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  const handleInputChange = (e: any, index: number) => {
    const updated = [...categories];
    updated[index].name = e.target.value;
    setCategories(updated);
  };

  const addCategory = () => {
    setCategories([...categories, { name: "" }]);
  };

  const removeCategory = (index: number) => {
    const updated = [...categories];
    updated.splice(index, 1);
    setCategories(updated);
  };

  const handleSubmit = async () => {
    try {
      await api.post(API_ENDPOINTS.INVENTORY.SAVE_CATEGORY_DATA, categories);
      toast.success("Categories added successfully!");
      setShowForm(false);
      setCategories([{ name: "" }]);
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      toast.error("Failed to save categories");
      console.error(error);
    }
  };

  return (
    <div className="mt-6">
      {categories.map((cat, i) => (
        <div key={i} className="mb-6 border p-4 rounded bg-gray-50 shadow-sm">
          <input
            type="text"
            placeholder="Category Name"
            value={cat.name}
            onChange={(e) => handleInputChange(e, i)}
            className="w-full border p-2 mb-2"
          />

          {categories.length > 1 && (
            <button
              className="text-red-500 text-sm"
              onClick={() => removeCategory(i)}
            >
              Remove This Category
            </button>
          )}
        </div>
      ))}

      <button
        onClick={addCategory}
        className="bg-blue-200 text-blue-800 px-4 py-2 rounded mb-4"
      >
        + Add Another Category
      </button>

      <button
        onClick={handleSubmit}
        className="bg-blue-600 text-white px-6 py-2 rounded"
      >
        Save Categories
      </button>
    </div>
  );
};

export default AddCategory;
